var _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightBlackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.75,
    y1: -0.75,
    x2: 10.4752,
    y2: -0.75,
    transform: "matrix(0.718612 -0.695377 0.69439 0.719632 1.51184 15.4016)",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.75,
    y1: -0.75,
    x2: 9.86903,
    y2: -0.75,
    transform: "matrix(-0.735452 -0.677613 0.676539 -0.736374 9.57788 7.59351)",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightBlackArrow);
export default __webpack_public_path__ + "static/media/RightBlackArrow.2996178e64fe5ea2d208166f765c4bf3.svg";
export { ForwardRef as ReactComponent };